<template>
    <div v-if="hmpg" style="padding-top: 45px;">



        <div v-for="it,i in hmpg" :key="i" style="">


            <bann1 v-if="it.type=='bann1'" :style="{'marginBottom':it.jiange}" :bann-data="it"/>

            <infoL v-if="it.type=='infoboxL'" :style="{'marginBottom':it.jiange}" :info-data="it"/>

            <infoR v-if="it.type=='infoboxR'" :style="{'marginBottom':it.jiange}" :info-data="it"/>

            <infoC v-if="it.type=='infoboxC'" :style="{'marginBottom':it.jiange}" :info-data="it"/>

            <newsbox v-if="it.type==='newsboxlist'" :style="{'marginBottom':it.jiange}" :news-data="it"/>


        </div>


    </div>
</template>

<script>

    import bann1 from './comp/bann1'
    import infoL from './comp/infoboxL'
    import infoR from './comp/infoboxR'
    import newsbox from './comp/newsboxlist'

    import infoC from './comp/infoboxC'

    export default {
        name: "index",
        components:{
            bann1,infoL,
            infoR,newsbox,infoC,
        },
        data(){
            return{



                hmpg:null,





            }
        },
        created() {
            var alldata=null;
            if(window.ttdata!==null&&window.ttdata!==undefined&&window.ttdata!=='') {
                try{
                    alldata =window.ttdata;
                    this.hmpg=alldata.hmpg;
                }catch (e) {
                    this.hmpg=null;
                }

            }



            return false;


        }
    }
</script>

<style scoped>

    .maxwidth{
        max-width: 1920px;
    }
    .maxwidth1140{
        max-width: 1140px;
    }


</style>



// WEBPACK FOOTER //
// src/components/index.vue